import config from 'config';

import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
// Components
import { QRCodeCanvas } from "qrcode.react";

type Props = {
  isLargeScreen: boolean;
}

const QRCode:FC<Props> = ({ isLargeScreen }) => {
  const result:any = useAppSelector(selectResult);
  const quiz:any = result?.quiz || null;

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;
  
  if (!quiz || !quiz.publicLeaderboard.quizQRCodeEnabled) return null;
  return (
    <div className="flex landscape:items-end portrait:justify-center">
      <div className="flex flex-col items-center">
        <div className="mb-4 flex flex-col gap-2 p-2 bg-white text-black rounded-xl w-max xl:p-4" style={{ width: '100% !important' }}>
          <QRCodeCanvas
            value={qrCodeLink}
            level="H"
            size={isLargeScreen ? 400 : 128}
            imageSettings={{
              src: quiz.publicLeaderboard.quizQRCodeLogo || '',
              width: isLargeScreen ? 120 : 40,
              height: isLargeScreen ? 120 : 40,
              excavate: true
            }}
          />
        </div>

        <div className="relative">
          <h2
            className="absolute w-full italic uppercase text-lg text-black font-extrabold text-center sm:text-4xl"
            style={{ transform: 'skewX(-9deg)' }}
          >
            {quiz?.publicLeaderboard.quizQRCodeTitle}
          </h2>
          <h2
            className="relative italic uppercase text-lg font-extrabold text-center sm:text-4xl z-10"
            style={{
              background: "linear-gradient(90deg, #e3722d, #f4d549)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {quiz?.publicLeaderboard.quizQRCodeTitle}
          </h2>
        </div>
      </div>
    </div>
  );
}

export default QRCode;
